var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("b-avatar", {
    attrs: {
      variant: "primary",
      src: _vm.avatar_url,
      text: _vm.avatar_letters,
      size: _vm.avatar_size,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }